import { createAction, props } from '@ngrx/store';
import { ARLTemplateTypeEntity } from '../../entities/a-r-l-template-type.entity';
import { AccountsReceivableLedgerTemplateEntity } from '../../entities/accounts-receivable-ledger-template.entity';
import { AccountsReceivableLedgerEntity } from '../../entities/accounts-receivable-ledger.entity';
import { LedgerImportDocumentTypes, LedgerImportEntity } from '../../entities/ledger-import.entity';
import { QuantityTypeEntity } from '../../entities/quantity-type.entity';
import { SfdtTemplateEntity } from '../../entities/sfdt-template.entity';
import {
    AccountsReceivableLedgerPostType,
    DaveMutationChangeAccountsReceivableLedgerArgs,
    DaveMutationChangeAccountsReceivableLedgerTemplateArgs,
    DaveMutationChangeLedgerImportArgs,
    DaveMutationCreateAccountsReceivableLedgerTemplateArgs,
    DaveMutationCreateArlTemplateTypeTypeArgs,
    DaveMutationCreateClosingOrPartialInvoiceFromLedgerImportArgs,
    DaveMutationCreateLedgerImportArgs,
    DaveMutationCreateLedgerImportFromLedgerImportArgs,
    DaveMutationCreateXRechnungFromLedgerImportArgs,
    DaveMutationDeleteAccountsReceivableLedgerArgs,
    DaveMutationDeleteAccountsReceivableLedgerTemplateArgs,
    DaveMutationDeleteArlTemplateTypeTypeArgs,
    InputMaybe,
    QueryAccountsReceivableLedgerArgs,
    QueryLedgerImportArgs,
    QueryLedgerImportTemplateArgs,
    Scalars,
} from '../../graphql-types';
import { Dictionary } from '@ngrx/entity';
import { Require } from '../../../helper/helper';

export const AccountsReceivableLedgerTemplateActionTypes = {
    UpdateAccountsReceivableLedgerTemplate: createAction('data/accounts-receivable-ledger-template/update', props<{ Payload: Array<AccountsReceivableLedgerTemplateEntity> }>()),
    GetAccountsReceivableLedgerTemplate: createAction('data/accounts-receivable-ledger-template/get'),
    AddAccountsReceivableLedgerTemplate: createAction('data/accounts-receivable-ledger-template/add', props<{ Payload: DaveMutationCreateAccountsReceivableLedgerTemplateArgs }>()),
    ChangeAccountsReceivableLedgerTemplate: createAction('data/accounts-receivable-ledger-template/change', props<{ Payload: DaveMutationChangeAccountsReceivableLedgerTemplateArgs }>()),
    DeleteAccountsReceivableLedgerTemplate: createAction('data/accounts-receivable-ledger-template/delete', props<{ Payload: DaveMutationDeleteAccountsReceivableLedgerTemplateArgs }>()),
};

export const AccountsReceivableLedgerActionTypes = {
    UpdateAll: createAction('data/accounts-receivable-ledger/updateAll', props<{ Payload: Array<AccountsReceivableLedgerEntity>; updateLatestUpdatedAt?: boolean }>()),
    UpdateMany: createAction('data/accounts-receivable-ledger/updateMany', props<{ Payload: Array<AccountsReceivableLedgerEntity>; updateLatestUpdatedAt?: boolean }>()),

    GetAccountsReceivableLedger: createAction('data/accounts-receivable-ledger/get', props<{ Payload: QueryAccountsReceivableLedgerArgs }>()),
    AddAccountsReceivableLedger: createAction('data/accounts-receivable-ledger/add', props<{ Payload: AccountsReceivableLedgerPostType }>()),
    ChangeAccountsReceivableLedger: createAction('data/accounts-receivable-ledger/change', props<{ Payload: DaveMutationChangeAccountsReceivableLedgerArgs }>()),
    //CreateAccountsReceivableLedgerFromCommission: createAction('data/accounts-receivable-ledger/addfromcomission', props<{ Payload: DaveMutationCreateAccountsReceivableLedgerFromCommissionArgs }>()),
    DeleteAccountsReceivableLedger: createAction('data/accounts-receivable-ledger/delete/request', props<{ Payload: DaveMutationDeleteAccountsReceivableLedgerArgs }>()),
    DeleteAccountsReceivableLedgerSuccess: createAction('data/accounts-receivable-ledger/delete/success', props<{ Payload: number }>()),
    DeleteAccountsReceivableLedgerFailure: createAction('data/accounts-receivable-ledger/delete/failure', props<{ Payload: { Errors: any; ToasterMessage?: string } }>()),
};
const prefix = 'data/ledger-import/';
export type AddLedgerImportWithDefaultsPayload = {
    accountsReceivableLedgerIds: number[];
    customerId?: number;
    commissionId?: number;
    documentType: LedgerImportDocumentTypes;
    ledgerImportId?: number;
    partnerOfficeId?: number;
    eventIds?: number[];
    status?: InputMaybe<Scalars['String']>;
    automaticInvoiceId?: boolean;
};
export const LedgerImportActionTypes = {
    UpdateAll: createAction(prefix + 'updateAll', props<{ Payload: Array<LedgerImportEntity>; updateLatestUpdatedAt?: boolean }>()),
    UpdateMany: createAction(prefix + 'updateMany', props<{ Payload: Array<LedgerImportEntity>; updateLatestUpdatedAt?: boolean }>()),
    RemoveMany: createAction('removeMany', props<{ Payload: number[] }>()),
    GetLedgerImports: createAction(prefix + 'get', props<{ Payload: QueryLedgerImportArgs }>()),
    SuccessChangeLedgerImport: createAction(prefix + 'successChangeLedgerImport', props<{ Payload: LedgerImportEntity }>()),

    AddLedgerImports: createAction(prefix + 'add', props<{ Payload: DaveMutationCreateLedgerImportArgs }>()),
    AddLedgerImportWithDefaults: createAction(
        prefix + 'add-with-defaults',
        props<{
            Payload: AddLedgerImportWithDefaultsPayload;
            ARLsForCalculateAmountFromArlIds?: Dictionary<AccountsReceivableLedgerEntity>
        }>(),
    ),
    ChangeLedgerImports: createAction(prefix + 'change', props<{ Payload: DaveMutationChangeLedgerImportArgs }>()),
    CreateXRechnungFromLedgerImport: createAction(prefix + 'createXRechnung', props<{ Payload: DaveMutationCreateXRechnungFromLedgerImportArgs }>()),
    CreateLedgerImportFromLedgerImport: createAction(prefix + 'duplicate/Request', props<{ Payload: DaveMutationCreateLedgerImportFromLedgerImportArgs }>()),
    CreateLedgerImportFromLedgerImportSuccess: createAction(prefix + 'duplicate/Success', props<{ Payload: LedgerImportEntity }>()),
    DeleteLedgerImport: createAction(
        prefix + 'delete',
        props<{ Payload: { id: number } }>(), // todo use DaveMutationDeleteLedgerImport
    ),
    GetSFDTTemplate: createAction(prefix + 'get/sfdt-template', props<{ Payload?: QueryLedgerImportTemplateArgs; withData?: boolean }>()),
    UpdateSFDTTemplate: createAction(prefix + 'update/sfdt-template', props<{ Payload: SfdtTemplateEntity[] }>()),

    CreatePartialInvoiceRequest: createAction(prefix + 'CreatePartialInvoice/Request', props<{ Payload: Pick<DaveMutationCreateClosingOrPartialInvoiceFromLedgerImportArgs, 'rootId' | 'amount' | 'percentageAmountInformation' | 'arls'>}>()),
    CreatePartialInvoiceSuccess: createAction(prefix + 'CreatePartialInvoice/Success', props<{ Payload: LedgerImportEntity }>()),
    CreatePartialInvoiceFailure: createAction(prefix + 'CreatePartialInvoice/Failure', props<{ Payload: { Errors: any; ToasterMessage?: string } }>()),

    CreateCumulativePartialInvoiceRequest: createAction(prefix + 'CreateCumulativePartialInvoice/Request', props<{ Payload: Require<Pick<DaveMutationCreateClosingOrPartialInvoiceFromLedgerImportArgs, 'rootId' | 'amount' | 'percentageAmountInformation' | 'arls' | 'ledgerImportIds' >, 'ledgerImportIds'>}>()),
    CreateCumulativePartialInvoiceSuccess: createAction(prefix + 'CreateCumulativePartialInvoice/Success', props<{ Payload: LedgerImportEntity }>()),
    CreateCumulativePartialInvoiceFailure: createAction(prefix + 'CreateCumulativePartialInvoice/Failure', props<{ Payload: { Errors: any; ToasterMessage?: string } }>()),

    CreateClosingInvoiceRequest: createAction(prefix + 'CreateClosingInvoice/Request', props<{ Payload: Pick<DaveMutationCreateClosingOrPartialInvoiceFromLedgerImportArgs, 'rootId' | 'ledgerImportIds' | 'arls'> }>()),
    CreateClosingInvoiceSuccess: createAction(prefix + 'CreateClosingInvoice/Success', props<{ Payload: LedgerImportEntity }>()),
    CreateClosingInvoiceFailure: createAction(prefix + 'CreateClosingInvoice/Failure', props<{ Payload: { Errors: any; ToasterMessage?: string } }>()),
};

export const QuantityTypeActions = {
    GetQuantityTypes: createAction('data/quantity-type/get'),
    UpdateQuantityTypes: createAction('data/quantity-type/update', props<{ Payload: Array<QuantityTypeEntity> }>()),
};
export const ARLTemplateTypeActions = {
    GetARLTemplateTypes: createAction('data/ARLTemplateType/get'),
    AddARLTemplateType: createAction('data/ARLTemplateType/add', props<{ Payload: DaveMutationCreateArlTemplateTypeTypeArgs }>()),
    DeleteARLTemplateType: createAction('data/ARLTemplateType/delete', props<{ Payload: DaveMutationDeleteArlTemplateTypeTypeArgs }>()),
    UpdateARLTemplateType: createAction('data/ARLTemplateType/update', props<{ Payload: Array<ARLTemplateTypeEntity> }>()),
};
